import React from 'react';
import PropTypes from 'prop-types';
import { openDidomiPreferences } from '../../../../util/openDidomiPreferences';

const PRIVACY_OPTIONS_ICON_URL = `${process.env.PUBLIC_URL}/images/privacyoptions29x14.png`;
const PRIVACY_OPTIONS_ICON_ALT = 'California Consumer Privacy Act (CCPA) Opt-Out Icon';

const PrivacyNoticeFooterLink = ({ onClick }) => {
  const handleClick = () => {
    openDidomiPreferences();
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      type="button"
      className="privacy-notice-link"
      onClick={handleClick}
    >
      <img
        src={PRIVACY_OPTIONS_ICON_URL}
        alt={PRIVACY_OPTIONS_ICON_ALT}
        className="privacy-notice-link__icon"
        width={29}
        height={14}
      />
      <span className="privacy-notice-link__text">Your Privacy Choices</span>
    </button>
  );
};

PrivacyNoticeFooterLink.propTypes = {
  onClick: PropTypes.func,
};

PrivacyNoticeFooterLink.defaultProps = {
  onClick: null,
};

export default PrivacyNoticeFooterLink;
